import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { CreditCard, Phone, Users, TrendingUp, CheckCircle, AlertCircle, Clock, XCircle } from "lucide-react";
import TelecallerHeader from "@/components/common/TelecallerHeader";
import { useRoleContext } from "@/hooks/useRoleContext";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import { storage } from "@/lib/storage";
import { getSubscriptionSummary } from "@/services/subscriptionData";
import AdminHeader from "@/components/common/AdminHeader";
import AdminDashboard from "./AdminDashboard";

interface Summary {
  Total_Subscriptions: number;
  Active_Subscriptions: number;
  Inactive_Subscriptions: number;
  Expiring_in_10_days: number;
  Expired_Subscriptions: number;
  Ready_For_Verification: number;
}

export default function TelecallerDashboard() {
  const navigate = useNavigate();
  const userDetails = useCurrentUser();
  const userData = storage.getUserData();
  const { branchCode } = useRoleContext();
  const bc = branchCode || (userDetails as any)?.branch_code || userData?.branch_code || "";
  const username = (userDetails?.username as string) || userData?.username || "";

  const [summary, setSummary] = useState<Summary | null>(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getSubscriptionSummary(bc || undefined);
      setSummary((res.data as any)?.Summary ?? null);
    } catch { /* silent */ } finally {
      setLoading(false);
    }
  }, [bc]);

  useEffect(() => { load(); }, [load]);


  const QUICK_ACTIONS = [
    {
      title: "Subscription Data",
      desc: "View all active, expiring and expired subscriptions",
      icon: CreditCard,
      path: "/subscription-data",
      gradient: "from-brand-500 to-brand-700",
    },
    {
      title: "Tele Record",
      desc: "Log calls and track renewal, verification & follow-ups",
      icon: Phone,
      path: "/tele-record",
      gradient: "from-emerald-500 to-emerald-700",
    },
  ];

  return (
    <AdminDashboard/>
  );
}
